/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import cn from "clsx";
import { useRef, useState } from "react";
import { MenuItem, SubMenu, ControlledMenu, useHover, useMenuState } from "@szhsin/react-menu";
import { solid } from "assets/icons";
const { faChevronDown, faChevronRight, faArrowRight } = solid;
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const NavMenu = (props) => {
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const { anchorProps, hoverProps } = useHover(isOpen, setOpen);
    const { submenu1Item } = props;

    const useMenu = () => {
        // eslint-disable-next-line no-unused-vars
        const [menuState, toggle] = useMenuState();
        return { menuState };
    };
    const menu = useMenu();

    const size = props?.size;
    const side = props?.side;
    const parent_position = props?.parent_position ?? 0;
    const position = props?.position;
    const _level = props?.level ?? 0;

    const last = position === size - 1 ? "last" : undefined;
    const level = Number(_level) + 1;
    const menuId = "menu_" + level + "_" + parent_position + "_" + position;

    const classNames = cn(
        "simplicity-menu-wrapper",
        "simplicity-menu-item",
        `level${level}`,
        side,
        last,
        menuId
    );

    const openMenuLevel1 = (event) => {
        if (event.code.toLowerCase() === "space") {
            event.preventDefault();
            setOpen(true);
        }
    };

    const setSubMenuHeight = () => {
        return submenu1Item.children.length * 50 + 2;
    };

    const setLevel1Open = (openState) => {
        if (openState) {
            return classNames + " is-open";
        }
        return classNames;
    };

    return (
        <div className={setLevel1Open(isOpen)}>
            <NavLink
                className="simplicity-menu-item level1"
                to={submenu1Item.url}
                title={submenu1Item.title}
                ref={ref}
                {...anchorProps}
                onKeyDown={(e) => openMenuLevel1(e)}
            >
                <div className="menu-item-root-target">
                    <div className="menu-item-root-target-text">{submenu1Item.title}</div>
                    <div className="chevron">
                        <FontAwesomeIcon icon={faChevronDown} size="xs" />
                    </div>
                </div>
            </NavLink>

            <ControlledMenu
                // do not put class names here
                {...menu.menuState}
                state={isOpen ? "open" : "closed"}
                {...hoverProps}
                anchorRef={ref}
                onClose={() => setOpen(false)}
                position="anchor"
                align={last ? "end" : "start"}
                gap={8}
                tabIndex={-1}
            >
                {submenu1Item.children.map((submenu2Item, ind) =>
                    submenu2Item.children.length > 0 ? (
                        <SubMenu
                            menuStyle={{ minHeight: setSubMenuHeight(submenu1Item.children.length) }}
                            key={ind}
                            direction={side}
                            position="initial"
                            shift={-50 * ind - 1}
                            gap={-1}
                            tabIndex={-1}
                            label={
                                <div className={"simplicity-menu-item level2 " + side} tabIndex={-1}>
                                    <NavLink to={submenu2Item.url}>{submenu2Item.title}
                                    </NavLink>

                                    <button
                                        className="submenu-trigger inactive"
                                        aria-expanded="false"
                                        aria-label="Expand this section of the menu"
                                        tabIndex={-1}
                                    >
                                        <FontAwesomeIcon
                                            icon={faChevronRight}
                                            className={side === "left" ? "fa-flip-horizontal" : ""}
                                            size="xs"
                                        />
                                    </button>
                                    <button
                                        className={`submenu-trigger active ${side}`}
                                        aria-expanded="false"
                                        aria-label="Expand this section of the menu"
                                        tabIndex={-1}
                                    >
                                        <FontAwesomeIcon
                                            icon={faArrowRight}
                                            className={side === "left" ? "fa-flip-horizontal" : ""}
                                            size="xs"
                                        />
                                    </button>
                                </div>
                            }
                        >
                            {submenu2Item.children.map((submenu3Item, ind) => (
                                <MenuItem key={ind} className={"simplicity-menu-item level3 " + side}>
                                    <NavLink to={submenu3Item.url} tabIndex={undefined}>
                                        {submenu3Item.title}
                                    </NavLink>
                                </MenuItem>
                            ))}
                        </SubMenu>
                    ) : (
                        <MenuItem className={"simplicity-menu-item level2 " + side} key={ind}>
                            <NavLink to={submenu2Item.url} tabIndex={undefined}>{submenu2Item.title}
                            </NavLink>
                            <div className="no-button-spacer"></div>
                        </MenuItem>
                    )
                )}
            </ControlledMenu>
        </div>
    );
};
